import React, { useState, useMemo, useEffect } from "react";
import RightSidebar from "./RightSidebar";
import BottomBar from "./BottomBar";
import StepTabs from "./StepTabs";
import { TransactionForm } from "./forms/transaction-form/transactionForm";
import { useTransactionData } from "../hooks/useTransaction";
import FloatingQueryCenter from "./FloatingQueryCenter";
import ConfirmationModal from "./ui/ConfirmationModal";
import TransactionConfirmModal from "./ui/TransactionConfirmModal";
import ViewModeBanner from "./ui/ViewModeBanner";


const TransactionDetail = ({isReport}) => {
  const [activeTab, setActiveTab] = useState("step1"); // ✅ Tab state
 
  const {
    isSelectorReadOnly,
    searchParams,
    formData,
    countries,
    existingTransactions,
    isReadOnly,
    modalOpen,
    modalMessage,
    modalHeading,
    handleTransactionChange,
    hasUnsavedChanges,
    handleChange,
    setModalOpen,

    entityId,
    validatePage,
    handleSubmit, // ✅ Make sure this is returned from the hook
    handleNext,
    setIsReadOnly,
    showTransactionConfirmModal,
    handleTransactionConfirmYes,
    handleTransactionConfirmNo
  } = useTransactionData();

  // Single source of truth for the lock: the status on screen. Reading the
  // localStorage copy left a validated page rendering unlocked until a reload.
  const checkStatus = formData.status === "Validated";

  const isEntityIdMissing = useMemo(() => {
      return entityId === null || entityId === undefined || entityId === "" || entityId === "None";
    } ,[formData.entityId])
   useEffect(() => {
    // Check if in view mode from URL
    const isViewMode = searchParams.get("view") === "true";
    const isReadOnlyFromUrl = searchParams.get("readonly") === "true";
    const isEditMode = searchParams.get("edit") === "true";

    if (isViewMode || isReadOnlyFromUrl || checkStatus) {
      console.log("Transaction in view/readonly mode or Validated. Setting isReadOnly to true.");
      setIsReadOnly(true);
    } else {
      setIsReadOnly(false);
    }
  }, [checkStatus, searchParams]);
  return (
    <>

      


      <div className={!isReport ? "transaction-detail": ""}>
        {!isReport && <StepTabs
          hasUnsavedChanges={hasUnsavedChanges}
          searchParams={searchParams}
          activeTab={activeTab}
          isEntityIdMissing={isEntityIdMissing}
          onTabChange={(tabId) => setActiveTab(tabId)}
        />}
        <ViewModeBanner
          isReadOnly={isReadOnly}
          status={formData?.status}
        />
<div className="form-section">
        <div className="transaction-form">
         

          <TransactionForm
            formData={formData}
            existingTransaction={existingTransactions}
            handleChange={handleChange}
            handleTransactionChange={handleTransactionChange}
            isReadOnly={isReadOnly || isReport}
            isSelectorReadOnly={isSelectorReadOnly}
            countries={countries}
            isReport={isReport}
            handleSubmit={handleSubmit}
          />
         
        </div>
         {!isReport && <RightSidebar
        transactionStatus={formData.status} />}
        </div>
      </div>

      {!isReport && (
  <BottomBar
    buttons={[
      {
        label: "Save",
        onClick: () => handleSubmit("save"),
        skipConfirmation: true,
        disabled: checkStatus
      },
      
      {
        label: "Next",
        onClick: handleNext
      },
      {
        label: "Validate & Lock",
        onClick: validatePage,
        disabled: checkStatus
      },
    ]}
  />
)}


       <ConfirmationModal
        isOpen={modalOpen}
        heading= {modalHeading}
        message={modalMessage}
        onClose={() => setModalOpen(false)}
      />

      <TransactionConfirmModal
        isOpen={showTransactionConfirmModal}
        onYes={handleTransactionConfirmYes}
        onNo={handleTransactionConfirmNo}
      />

{/* <FloatingMessageCenter /> */}
  <FloatingQueryCenter />
    </>
  );
};

export default TransactionDetail;
